import { createFileRoute } from "@tanstack/react-router";
import { KarrierePage, karriereHead } from "@/pages/KarrierePage";

export const Route = createFileRoute("/de/karriere")({
  head: () => karriereHead("de"),
  component: () => <KarrierePage locale="de" />,
});
